import { render, staticRenderFns } from "./CreateAdditionalField.vue?vue&type=template&id=86fd0960"
import script from "./CreateAdditionalField.vue?vue&type=script&lang=js"
export * from "./CreateAdditionalField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports